import * as ambassadorWixApiInfraV1PromptProxy from './api-infra-v1-prompt-proxy-prompts.http.js';
import * as ambassadorWixApiInfraV1PromptProxyTypes from './api-infra-v1-prompt-proxy-prompts.types.js';
import * as ambassadorWixApiInfraV1PromptProxyUniversalTypes from './api-infra-v1-prompt-proxy-prompts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function generateContentByPromptObject(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GenerateContentByPromptObjectRequest,
  ambassadorWixApiInfraV1PromptProxyTypes.GenerateContentByPromptObjectRequest,
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GenerateContentByPromptObjectResponse,
  ambassadorWixApiInfraV1PromptProxyTypes.GenerateContentByPromptObjectResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixApiInfraV1PromptProxy.generateContentByPromptObject(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/generate-content-by-prompt-object',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateTextByPromptObjectStreamed(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GenerateTextByPromptObjectRequest,
  ambassadorWixApiInfraV1PromptProxyTypes.GenerateTextByPromptObjectRequest,
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GeneratedTextChunk,
  ambassadorWixApiInfraV1PromptProxyTypes.GeneratedTextChunk
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixApiInfraV1PromptProxy.generateTextByPromptObjectStreamed(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/generate-by-prompt-object-streamed',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateContentByPromptObjectAsync(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GenerateContentByPromptObjectRequest,
  ambassadorWixApiInfraV1PromptProxyTypes.GenerateContentByPromptObjectRequest,
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GenerateContentByPromptObjectResponse,
  ambassadorWixApiInfraV1PromptProxyTypes.GenerateContentByPromptObjectResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixApiInfraV1PromptProxy.generateContentByPromptObjectAsync(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/generate-content-by-prompt-object-async',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateAudioStreamed(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GenerateAudioRequest,
  ambassadorWixApiInfraV1PromptProxyTypes.GenerateAudioRequest,
  ambassadorWixApiInfraV1PromptProxyUniversalTypes.GeneratedAudioChunk,
  ambassadorWixApiInfraV1PromptProxyTypes.GeneratedAudioChunk
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixApiInfraV1PromptProxy.generateAudioStreamed(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/generate-audio-streamed',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  PromptProxy as PromptProxyOriginal,
  GenerationCompletedResultEvent as GenerationCompletedResultEventOriginal,
  GenerateContentModelResponse as GenerateContentModelResponseOriginal,
  GenerateContentModelResponseResponseOneOf as GenerateContentModelResponseResponseOneOfOriginal,
  GeneratedContent as GeneratedContentOriginal,
  TextContent as TextContentOriginal,
  MediaContent as MediaContentOriginal,
  ThinkingTextContent as ThinkingTextContentOriginal,
  ToolUseContent as ToolUseContentOriginal,
  V1TokenUsage as V1TokenUsageOriginal,
  ResponseMetadata as ResponseMetadataOriginal,
  OpenaiproxyV1CreateChatCompletionResponse as OpenaiproxyV1CreateChatCompletionResponseOriginal,
  OpenaiproxyV1ChatCompletionMessage as OpenaiproxyV1ChatCompletionMessageOriginal,
  V1ChatCompletionMessageFunctionWithArgs as V1ChatCompletionMessageFunctionWithArgsOriginal,
  OpenaiproxyV1ChatCompletionMessageImageUrlContent as OpenaiproxyV1ChatCompletionMessageImageUrlContentOriginal,
  OpenaiproxyV1ChatCompletionMessageMessageRole as OpenaiproxyV1ChatCompletionMessageMessageRoleOriginal,
  OpenaiproxyV1ChatCompletionMessageMessageRoleWithLiterals as OpenaiproxyV1ChatCompletionMessageMessageRoleWithLiteralsOriginal,
  V1ChatCompletionMessageToolCall as V1ChatCompletionMessageToolCallOriginal,
  OpenaiproxyV1ChatCompletionMessageContentPart as OpenaiproxyV1ChatCompletionMessageContentPartOriginal,
  OpenaiproxyV1ChatCompletionMessageContentPartContentValueOneOf as OpenaiproxyV1ChatCompletionMessageContentPartContentValueOneOfOriginal,
  CreateChatCompletionResponsePromptTokenDetails as CreateChatCompletionResponsePromptTokenDetailsOriginal,
  CreateChatCompletionResponseCompletionTokenDetails as CreateChatCompletionResponseCompletionTokenDetailsOriginal,
  OpenaiproxyV1Model as OpenaiproxyV1ModelOriginal,
  OpenaiproxyV1ModelWithLiterals as OpenaiproxyV1ModelWithLiteralsOriginal,
  OpenaiproxyV1CreateChatCompletionResponseChoice as OpenaiproxyV1CreateChatCompletionResponseChoiceOriginal,
  OpenaiproxyV1CreateChatCompletionResponseTokenUsage as OpenaiproxyV1CreateChatCompletionResponseTokenUsageOriginal,
  CreateChatCompletionResponse as CreateChatCompletionResponseOriginal,
  V1ChatCompletionMessage as V1ChatCompletionMessageOriginal,
  FunctionWithArgs as FunctionWithArgsOriginal,
  ChatCompletionMessageImageUrlContent as ChatCompletionMessageImageUrlContentOriginal,
  ChatCompletionMessageMessageRole as ChatCompletionMessageMessageRoleOriginal,
  ChatCompletionMessageMessageRoleWithLiterals as ChatCompletionMessageMessageRoleWithLiteralsOriginal,
  ToolCall as ToolCallOriginal,
  ChatCompletionMessageContentPart as ChatCompletionMessageContentPartOriginal,
  ChatCompletionMessageContentPartContentValueOneOf as ChatCompletionMessageContentPartContentValueOneOfOriginal,
  PromptTokenDetails as PromptTokenDetailsOriginal,
  CompletionTokenDetails as CompletionTokenDetailsOriginal,
  V1Model as V1ModelOriginal,
  V1ModelWithLiterals as V1ModelWithLiteralsOriginal,
  CreateChatCompletionResponseChoice as CreateChatCompletionResponseChoiceOriginal,
  CreateChatCompletionResponseTokenUsage as CreateChatCompletionResponseTokenUsageOriginal,
  GenerateContentResponse as GenerateContentResponseOriginal,
  Candidate as CandidateOriginal,
  CandidateContent as CandidateContentOriginal,
  FunctionCall as FunctionCallOriginal,
  ExecutableCode as ExecutableCodeOriginal,
  Language as LanguageOriginal,
  LanguageWithLiterals as LanguageWithLiteralsOriginal,
  V1CodeExecutionResult as V1CodeExecutionResultOriginal,
  Outcome as OutcomeOriginal,
  OutcomeWithLiterals as OutcomeWithLiteralsOriginal,
  Blob as BlobOriginal,
  CandidateContentPart as CandidateContentPartOriginal,
  FinishReason as FinishReasonOriginal,
  FinishReasonWithLiterals as FinishReasonWithLiteralsOriginal,
  SafetyRating as SafetyRatingOriginal,
  HarmCategory as HarmCategoryOriginal,
  HarmCategoryWithLiterals as HarmCategoryWithLiteralsOriginal,
  HarmProbability as HarmProbabilityOriginal,
  HarmProbabilityWithLiterals as HarmProbabilityWithLiteralsOriginal,
  CandidateCitationMetadata as CandidateCitationMetadataOriginal,
  PublicationDate as PublicationDateOriginal,
  CandidateCitationMetadataCitation as CandidateCitationMetadataCitationOriginal,
  GroundingMetadata as GroundingMetadataOriginal,
  SearchEntryPoint as SearchEntryPointOriginal,
  GroundingChunk as GroundingChunkOriginal,
  GroundingChunkChunkTypeOneOf as GroundingChunkChunkTypeOneOfOriginal,
  Web as WebOriginal,
  RetrievedContext as RetrievedContextOriginal,
  GroundingSupport as GroundingSupportOriginal,
  Segment as SegmentOriginal,
  RetrievalMetadata as RetrievalMetadataOriginal,
  UsageMetadata as UsageMetadataOriginal,
  ModalityTokenCount as ModalityTokenCountOriginal,
  Modality as ModalityOriginal,
  ModalityWithLiterals as ModalityWithLiteralsOriginal,
  InvokeAnthropicClaudeModelResponse as InvokeAnthropicClaudeModelResponseOriginal,
  ResponseTypeType as ResponseTypeTypeOriginal,
  ResponseTypeTypeWithLiterals as ResponseTypeTypeWithLiteralsOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  Usage as UsageOriginal,
  ContentBlock as ContentBlockOriginal,
  ContentBlockTypeOneOf as ContentBlockTypeOneOfOriginal,
  Text as TextOriginal,
  CacheControl as CacheControlOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  V1ImageUrl as V1ImageUrlOriginal,
  MediaType as MediaTypeOriginal,
  MediaTypeWithLiterals as MediaTypeWithLiteralsOriginal,
  ToolUse as ToolUseOriginal,
  ToolResult as ToolResultOriginal,
  SimpleContentBlock as SimpleContentBlockOriginal,
  SimpleContentBlockTypeOneOf as SimpleContentBlockTypeOneOfOriginal,
  Thinking as ThinkingOriginal,
  RedactedThinking as RedactedThinkingOriginal,
  V1InvokeAnthropicClaudeModelResponse as V1InvokeAnthropicClaudeModelResponseOriginal,
  GoogleproxyV1ResponseTypeType as GoogleproxyV1ResponseTypeTypeOriginal,
  GoogleproxyV1ResponseTypeTypeWithLiterals as GoogleproxyV1ResponseTypeTypeWithLiteralsOriginal,
  V1MessageRoleRole as V1MessageRoleRoleOriginal,
  V1MessageRoleRoleWithLiterals as V1MessageRoleRoleWithLiteralsOriginal,
  GoogleproxyV1Usage as GoogleproxyV1UsageOriginal,
  GoogleproxyV1ContentBlock as GoogleproxyV1ContentBlockOriginal,
  GoogleproxyV1ContentBlockTypeOneOf as GoogleproxyV1ContentBlockTypeOneOfOriginal,
  GoogleproxyV1Text as GoogleproxyV1TextOriginal,
  GoogleproxyV1CacheControl as GoogleproxyV1CacheControlOriginal,
  V1CacheControlType as V1CacheControlTypeOriginal,
  V1CacheControlTypeWithLiterals as V1CacheControlTypeWithLiteralsOriginal,
  GoogleproxyV1ImageUrl as GoogleproxyV1ImageUrlOriginal,
  V1ImageMediaTypeMediaType as V1ImageMediaTypeMediaTypeOriginal,
  V1ImageMediaTypeMediaTypeWithLiterals as V1ImageMediaTypeMediaTypeWithLiteralsOriginal,
  GoogleproxyV1ToolUse as GoogleproxyV1ToolUseOriginal,
  GoogleproxyV1ToolResult as GoogleproxyV1ToolResultOriginal,
  V1SimpleContentBlock as V1SimpleContentBlockOriginal,
  V1SimpleContentBlockTypeOneOf as V1SimpleContentBlockTypeOneOfOriginal,
  GoogleproxyV1Thinking as GoogleproxyV1ThinkingOriginal,
  GoogleproxyV1RedactedThinking as GoogleproxyV1RedactedThinkingOriginal,
  InvokeAnthropicModelResponse as InvokeAnthropicModelResponseOriginal,
  V1ResponseTypeType as V1ResponseTypeTypeOriginal,
  V1ResponseTypeTypeWithLiterals as V1ResponseTypeTypeWithLiteralsOriginal,
  MessageRoleRole as MessageRoleRoleOriginal,
  MessageRoleRoleWithLiterals as MessageRoleRoleWithLiteralsOriginal,
  V1Usage as V1UsageOriginal,
  UsageCacheCreation as UsageCacheCreationOriginal,
  UsageServerToolUse as UsageServerToolUseOriginal,
  Container as ContainerOriginal,
  V1ContentBlock as V1ContentBlockOriginal,
  V1ContentBlockTypeOneOf as V1ContentBlockTypeOneOfOriginal,
  V1Text as V1TextOriginal,
  V1CacheControl as V1CacheControlOriginal,
  CacheControlType as CacheControlTypeOriginal,
  CacheControlTypeWithLiterals as CacheControlTypeWithLiteralsOriginal,
  Citation as CitationOriginal,
  CitationTypeOneOf as CitationTypeOneOfOriginal,
  CharLocationCitation as CharLocationCitationOriginal,
  PageLocationCitation as PageLocationCitationOriginal,
  ContentBlockLocationCitation as ContentBlockLocationCitationOriginal,
  WebSearchResultLocationCitation as WebSearchResultLocationCitationOriginal,
  SearchResultLocationCitation as SearchResultLocationCitationOriginal,
  AnthropicV1ImageUrl as AnthropicV1ImageUrlOriginal,
  ImageMediaTypeMediaType as ImageMediaTypeMediaTypeOriginal,
  ImageMediaTypeMediaTypeWithLiterals as ImageMediaTypeMediaTypeWithLiteralsOriginal,
  V1ToolUse as V1ToolUseOriginal,
  V1ToolResult as V1ToolResultOriginal,
  ToolResultContentBlock as ToolResultContentBlockOriginal,
  ToolResultContentBlockTypeOneOf as ToolResultContentBlockTypeOneOfOriginal,
  DocumentContent as DocumentContentOriginal,
  DocumentSource as DocumentSourceOriginal,
  CitationsEnabled as CitationsEnabledOriginal,
  ToolResultSearchResult as ToolResultSearchResultOriginal,
  V1Thinking as V1ThinkingOriginal,
  V1RedactedThinking as V1RedactedThinkingOriginal,
  McpToolUse as McpToolUseOriginal,
  ServerToolUse as ServerToolUseOriginal,
  WebSearchToolResult as WebSearchToolResultOriginal,
  WebSearchToolResultContentOneOf as WebSearchToolResultContentOneOfOriginal,
  WebSearchResultList as WebSearchResultListOriginal,
  WebSearchResult as WebSearchResultOriginal,
  WebSearchToolResultError as WebSearchToolResultErrorOriginal,
  CodeExecutionToolResult as CodeExecutionToolResultOriginal,
  CodeExecutionToolResultContentOneOf as CodeExecutionToolResultContentOneOfOriginal,
  CodeExecutionResult as CodeExecutionResultOriginal,
  CodeExecutionToolResultError as CodeExecutionToolResultErrorOriginal,
  ContainerUpload as ContainerUploadOriginal,
  WebFetchToolResult as WebFetchToolResultOriginal,
  WebFetchToolResultContentOneOf as WebFetchToolResultContentOneOfOriginal,
  WebFetchToolResultContentSuccess as WebFetchToolResultContentSuccessOriginal,
  WebFetchToolResultContentError as WebFetchToolResultContentErrorOriginal,
  InvokeLlamaModelResponse as InvokeLlamaModelResponseOriginal,
  InvokeConverseResponse as InvokeConverseResponseOriginal,
  ConverseMessage as ConverseMessageOriginal,
  ConverseContentBlock as ConverseContentBlockOriginal,
  ConverseContentBlockContentOneOf as ConverseContentBlockContentOneOfOriginal,
  ConverseReasoningContent as ConverseReasoningContentOriginal,
  ReasoningText as ReasoningTextOriginal,
  ConverseToolUse as ConverseToolUseOriginal,
  ConverseToolResult as ConverseToolResultOriginal,
  ConverseToolResultContent as ConverseToolResultContentOriginal,
  ConverseToolResultContentContentOneOf as ConverseToolResultContentContentOneOfOriginal,
  Output as OutputOriginal,
  InvokeConverseResponseTokenUsage as InvokeConverseResponseTokenUsageOriginal,
  Metrics as MetricsOriginal,
  ConversePerformanceConfig as ConversePerformanceConfigOriginal,
  InvokeMlPlatformLlamaModelResponse as InvokeMlPlatformLlamaModelResponseOriginal,
  InvokeChatCompletionResponse as InvokeChatCompletionResponseOriginal,
  PerplexityMessage as PerplexityMessageOriginal,
  PerplexityMessageMessageRole as PerplexityMessageMessageRoleOriginal,
  PerplexityMessageMessageRoleWithLiterals as PerplexityMessageMessageRoleWithLiteralsOriginal,
  PerplexityModel as PerplexityModelOriginal,
  PerplexityModelWithLiterals as PerplexityModelWithLiteralsOriginal,
  InvokeChatCompletionResponseChoice as InvokeChatCompletionResponseChoiceOriginal,
  PerplexityImageDescriptor as PerplexityImageDescriptorOriginal,
  InvokeChatCompletionResponseUsage as InvokeChatCompletionResponseUsageOriginal,
  CreateImageResponse as CreateImageResponseOriginal,
  V1ImageObject as V1ImageObjectOriginal,
  V1ImageModel as V1ImageModelOriginal,
  V1ImageModelWithLiterals as V1ImageModelWithLiteralsOriginal,
  V1TextToImageResponse as V1TextToImageResponseOriginal,
  ImageObject as ImageObjectOriginal,
  ImageModel as ImageModelOriginal,
  ImageModelWithLiterals as ImageModelWithLiteralsOriginal,
  GenerateCoreResponse as GenerateCoreResponseOriginal,
  ImageCoreModel as ImageCoreModelOriginal,
  ImageCoreModelWithLiterals as ImageCoreModelWithLiteralsOriginal,
  GenerateStableDiffusionResponse as GenerateStableDiffusionResponseOriginal,
  ImageStableDiffusionModel as ImageStableDiffusionModelOriginal,
  ImageStableDiffusionModelWithLiterals as ImageStableDiffusionModelWithLiteralsOriginal,
  GenerateAnImageResponse as GenerateAnImageResponseOriginal,
  ResultObject as ResultObjectOriginal,
  CreatePredictionResponse as CreatePredictionResponseOriginal,
  CreatePredictionResponseTokenUsage as CreatePredictionResponseTokenUsageOriginal,
  EditImageWithPromptResponse as EditImageWithPromptResponseOriginal,
  EditImageWithPromptRequestModel as EditImageWithPromptRequestModelOriginal,
  EditImageWithPromptRequestModelWithLiterals as EditImageWithPromptRequestModelWithLiteralsOriginal,
  TextToImageResponse as TextToImageResponseOriginal,
  TextToImageTaskResult as TextToImageTaskResultOriginal,
  V1GenerateImageResponse as V1GenerateImageResponseOriginal,
  Prediction as PredictionOriginal,
  SafetyAttributes as SafetyAttributesOriginal,
  GenerateVideoResponse as GenerateVideoResponseOriginal,
  GeneratedVideo as GeneratedVideoOriginal,
  GenerateImageMlPlatformResponse as GenerateImageMlPlatformResponseOriginal,
  CreateImageOpenAiResponse as CreateImageOpenAiResponseOriginal,
  OpenAiImageModel as OpenAiImageModelOriginal,
  OpenAiImageModelWithLiterals as OpenAiImageModelWithLiteralsOriginal,
  V1ImageUsage as V1ImageUsageOriginal,
  OpenAiImageTokenDetails as OpenAiImageTokenDetailsOriginal,
  EditImageOpenAiResponse as EditImageOpenAiResponseOriginal,
  V1CreateChatCompletionResponse as V1CreateChatCompletionResponseOriginal,
  GoogleproxyV1ChatCompletionMessage as GoogleproxyV1ChatCompletionMessageOriginal,
  V1ChatCompletionMessageImageUrlContent as V1ChatCompletionMessageImageUrlContentOriginal,
  V1ChatCompletionMessageMessageRole as V1ChatCompletionMessageMessageRoleOriginal,
  V1ChatCompletionMessageMessageRoleWithLiterals as V1ChatCompletionMessageMessageRoleWithLiteralsOriginal,
  V1ChatCompletionMessageContentPart as V1ChatCompletionMessageContentPartOriginal,
  V1ChatCompletionMessageContentPartContentValueOneOf as V1ChatCompletionMessageContentPartContentValueOneOfOriginal,
  ChatCompletionModel as ChatCompletionModelOriginal,
  ChatCompletionModelWithLiterals as ChatCompletionModelWithLiteralsOriginal,
  V1CreateChatCompletionResponseChoice as V1CreateChatCompletionResponseChoiceOriginal,
  V1CreateChatCompletionResponseTokenUsage as V1CreateChatCompletionResponseTokenUsageOriginal,
  InvokeMlPlatformOpenAIChatCompletionRawResponse as InvokeMlPlatformOpenAIChatCompletionRawResponseOriginal,
  ChatCompletionMessage as ChatCompletionMessageOriginal,
  ImageUrlContent as ImageUrlContentOriginal,
  MessageRole as MessageRoleOriginal,
  MessageRoleWithLiterals as MessageRoleWithLiteralsOriginal,
  ContentPart as ContentPartOriginal,
  ContentPartContentValueOneOf as ContentPartContentValueOneOfOriginal,
  Choice as ChoiceOriginal,
  TokenUsage as TokenUsageOriginal,
  VideoInferenceResponse as VideoInferenceResponseOriginal,
  VideoInferenceTaskResult as VideoInferenceTaskResultOriginal,
  V1OpenAiResponsesResponse as V1OpenAiResponsesResponseOriginal,
  OpenAiResponsesResponseIncompleteDetails as OpenAiResponsesResponseIncompleteDetailsOriginal,
  V1ResponsesModel as V1ResponsesModelOriginal,
  V1ResponsesModelWithLiterals as V1ResponsesModelWithLiteralsOriginal,
  V1ResponsesOutput as V1ResponsesOutputOriginal,
  V1ResponsesOutputOutputOneOf as V1ResponsesOutputOutputOneOfOriginal,
  V1ResponsesOutputMessage as V1ResponsesOutputMessageOriginal,
  V1OutputAnnotation as V1OutputAnnotationOriginal,
  V1OutputAnnotationAnnotationTypeOneOf as V1OutputAnnotationAnnotationTypeOneOfOriginal,
  V1UrlCitation as V1UrlCitationOriginal,
  ResponsesOutputMessageOutputContent as ResponsesOutputMessageOutputContentOriginal,
  V1ResponsesWebSearchToolCall as V1ResponsesWebSearchToolCallOriginal,
  ResponsesWebSearchToolCallAction as ResponsesWebSearchToolCallActionOriginal,
  V1ResponsesFunctionToolCall as V1ResponsesFunctionToolCallOriginal,
  V1ResponsesReasoningOutput as V1ResponsesReasoningOutputOriginal,
  V1ResponsesReasoningSummaryContent as V1ResponsesReasoningSummaryContentOriginal,
  V1ResponsesReasoningContent as V1ResponsesReasoningContentOriginal,
  V1ResponsesCodeInterpreterToolCall as V1ResponsesCodeInterpreterToolCallOriginal,
  V1ResponsesCodeInterpreterOutput as V1ResponsesCodeInterpreterOutputOriginal,
  V1ResponsesCodeInterpreterOutputOutputTypeOneOf as V1ResponsesCodeInterpreterOutputOutputTypeOneOfOriginal,
  V1ResponsesCodeInterpreterLogsOutput as V1ResponsesCodeInterpreterLogsOutputOriginal,
  V1ResponsesCodeInterpreterImageOutput as V1ResponsesCodeInterpreterImageOutputOriginal,
  V1ResponsesReasoning as V1ResponsesReasoningOriginal,
  V1ResponsesTokenUsage as V1ResponsesTokenUsageOriginal,
  V1ResponsesInputTokensDetails as V1ResponsesInputTokensDetailsOriginal,
  V1ResponsesOutputTokensDetails as V1ResponsesOutputTokensDetailsOriginal,
  OpenAiResponsesResponse as OpenAiResponsesResponseOriginal,
  IncompleteDetails as IncompleteDetailsOriginal,
  ResponsesModel as ResponsesModelOriginal,
  ResponsesModelWithLiterals as ResponsesModelWithLiteralsOriginal,
  ResponsesOutput as ResponsesOutputOriginal,
  ResponsesOutputOutputOneOf as ResponsesOutputOutputOneOfOriginal,
  ResponsesOutputMessage as ResponsesOutputMessageOriginal,
  OutputAnnotation as OutputAnnotationOriginal,
  OutputAnnotationAnnotationTypeOneOf as OutputAnnotationAnnotationTypeOneOfOriginal,
  UrlCitation as UrlCitationOriginal,
  OutputContent as OutputContentOriginal,
  ResponsesWebSearchToolCall as ResponsesWebSearchToolCallOriginal,
  Action as ActionOriginal,
  ResponsesFunctionToolCall as ResponsesFunctionToolCallOriginal,
  ResponsesReasoningOutput as ResponsesReasoningOutputOriginal,
  ResponsesReasoningSummaryContent as ResponsesReasoningSummaryContentOriginal,
  ResponsesReasoningContent as ResponsesReasoningContentOriginal,
  ResponsesCodeInterpreterToolCall as ResponsesCodeInterpreterToolCallOriginal,
  ResponsesCodeInterpreterOutput as ResponsesCodeInterpreterOutputOriginal,
  ResponsesCodeInterpreterOutputOutputTypeOneOf as ResponsesCodeInterpreterOutputOutputTypeOneOfOriginal,
  ResponsesCodeInterpreterLogsOutput as ResponsesCodeInterpreterLogsOutputOriginal,
  ResponsesCodeInterpreterImageOutput as ResponsesCodeInterpreterImageOutputOriginal,
  ResponsesReasoning as ResponsesReasoningOriginal,
  ResponsesTokenUsage as ResponsesTokenUsageOriginal,
  ResponsesInputTokensDetails as ResponsesInputTokensDetailsOriginal,
  ResponsesOutputTokensDetails as ResponsesOutputTokensDetailsOriginal,
  CreateVideoResponse as CreateVideoResponseOriginal,
  VideoJob as VideoJobOriginal,
  ErrorInfo as ErrorInfoOriginal,
  InvokeCustomOpenAiModelResponse as InvokeCustomOpenAiModelResponseOriginal,
  Fireworks_proxyV1ChatCompletionMessage as Fireworks_proxyV1ChatCompletionMessageOriginal,
  ChatCompletionMessageFunctionWithArgs as ChatCompletionMessageFunctionWithArgsOriginal,
  Fireworks_proxyV1ChatCompletionMessageImageUrlContent as Fireworks_proxyV1ChatCompletionMessageImageUrlContentOriginal,
  Fireworks_proxyV1ChatCompletionMessageMessageRole as Fireworks_proxyV1ChatCompletionMessageMessageRoleOriginal,
  Fireworks_proxyV1ChatCompletionMessageMessageRoleWithLiterals as Fireworks_proxyV1ChatCompletionMessageMessageRoleWithLiteralsOriginal,
  ChatCompletionMessageToolCall as ChatCompletionMessageToolCallOriginal,
  Fireworks_proxyV1ChatCompletionMessageContentPart as Fireworks_proxyV1ChatCompletionMessageContentPartOriginal,
  Fireworks_proxyV1ChatCompletionMessageContentPartContentValueOneOf as Fireworks_proxyV1ChatCompletionMessageContentPartContentValueOneOfOriginal,
  InvokeCustomOpenAiModelResponsePromptTokenDetails as InvokeCustomOpenAiModelResponsePromptTokenDetailsOriginal,
  InvokeCustomOpenAiModelResponseCompletionTokenDetails as InvokeCustomOpenAiModelResponseCompletionTokenDetailsOriginal,
  InvokeCustomOpenAiModelResponseChoice as InvokeCustomOpenAiModelResponseChoiceOriginal,
  InvokeCustomOpenAiModelResponseTokenUsage as InvokeCustomOpenAiModelResponseTokenUsageOriginal,
  CreateContentTaskResponse as CreateContentTaskResponseOriginal,
  CommonContentTaskResponse as CommonContentTaskResponseOriginal,
  TaskError as TaskErrorOriginal,
  TaskContent as TaskContentOriginal,
  TaskUsage as TaskUsageOriginal,
  GenerateImageResponse as GenerateImageResponseOriginal,
  ImageData as ImageDataOriginal,
  ImageError as ImageErrorOriginal,
  ImageUsage as ImageUsageOriginal,
  GenerateContentByPromptObjectRequest as GenerateContentByPromptObjectRequestOriginal,
  Prompt as PromptOriginal,
  PromptModelRequestOneOf as PromptModelRequestOneOfOriginal,
  FallbackPromptConfig as FallbackPromptConfigOriginal,
  OpenaiproxyV1CreateChatCompletionRequest as OpenaiproxyV1CreateChatCompletionRequestOriginal,
  OpenaiproxyV1CreateChatCompletionRequestFunctionCallOneOf as OpenaiproxyV1CreateChatCompletionRequestFunctionCallOneOfOriginal,
  CreateChatCompletionRequestFunctionSignature as CreateChatCompletionRequestFunctionSignatureOriginal,
  V1CreateChatCompletionRequestTool as V1CreateChatCompletionRequestToolOriginal,
  V1FineTuningSpec as V1FineTuningSpecOriginal,
  OpenaiproxyV1CreateChatCompletionRequestResponseFormat as OpenaiproxyV1CreateChatCompletionRequestResponseFormatOriginal,
  CreateChatCompletionRequest as CreateChatCompletionRequestOriginal,
  CreateChatCompletionRequestFunctionCallOneOf as CreateChatCompletionRequestFunctionCallOneOfOriginal,
  FunctionSignature as FunctionSignatureOriginal,
  CreateChatCompletionRequestTool as CreateChatCompletionRequestToolOriginal,
  CreateChatCompletionRequestResponseFormat as CreateChatCompletionRequestResponseFormatOriginal,
  GenerateContentRequest as GenerateContentRequestOriginal,
  GoogleproxyV1Model as GoogleproxyV1ModelOriginal,
  GoogleproxyV1ModelWithLiterals as GoogleproxyV1ModelWithLiteralsOriginal,
  Content as ContentOriginal,
  ContentRole as ContentRoleOriginal,
  ContentRoleWithLiterals as ContentRoleWithLiteralsOriginal,
  V1ContentPart as V1ContentPartOriginal,
  ContentData as ContentDataOriginal,
  FunctionResponse as FunctionResponseOriginal,
  FunctionResponsePart as FunctionResponsePartOriginal,
  FunctionResponsePartDataOneOf as FunctionResponsePartDataOneOfOriginal,
  FunctionResponseBlob as FunctionResponseBlobOriginal,
  MediaResolution as MediaResolutionOriginal,
  MediaResolutionLevel as MediaResolutionLevelOriginal,
  MediaResolutionLevelWithLiterals as MediaResolutionLevelWithLiteralsOriginal,
  SystemInstruction as SystemInstructionOriginal,
  GoogleproxyV1Tool as GoogleproxyV1ToolOriginal,
  DynamicRetrievalConfigMode as DynamicRetrievalConfigModeOriginal,
  DynamicRetrievalConfigModeWithLiterals as DynamicRetrievalConfigModeWithLiteralsOriginal,
  DynamicRetrievalConfig as DynamicRetrievalConfigOriginal,
  Environment as EnvironmentOriginal,
  EnvironmentWithLiterals as EnvironmentWithLiteralsOriginal,
  FunctionDeclaration as FunctionDeclarationOriginal,
  GoogleSearchRetrieval as GoogleSearchRetrievalOriginal,
  CodeExecution as CodeExecutionOriginal,
  GoogleSearch as GoogleSearchOriginal,
  ComputerUse as ComputerUseOriginal,
  SafetySetting as SafetySettingOriginal,
  Threshold as ThresholdOriginal,
  ThresholdWithLiterals as ThresholdWithLiteralsOriginal,
  GenerationConfig as GenerationConfigOriginal,
  GenerationThinkingConfig as GenerationThinkingConfigOriginal,
  ImageConfig as ImageConfigOriginal,
  ImageOutputOptions as ImageOutputOptionsOriginal,
  PersonGeneration as PersonGenerationOriginal,
  PersonGenerationWithLiterals as PersonGenerationWithLiteralsOriginal,
  V1ToolConfig as V1ToolConfigOriginal,
  FunctionCallingConfig as FunctionCallingConfigOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  FineTuningSpec as FineTuningSpecOriginal,
  InvokeAnthropicClaudeModelRequest as InvokeAnthropicClaudeModelRequestOriginal,
  InputSchema as InputSchemaOriginal,
  Model as ModelOriginal,
  ModelWithLiterals as ModelWithLiteralsOriginal,
  AnthropicClaudeMessage as AnthropicClaudeMessageOriginal,
  Tool as ToolOriginal,
  ToolChoice as ToolChoiceOriginal,
  ToolChoiceType as ToolChoiceTypeOriginal,
  ToolChoiceTypeWithLiterals as ToolChoiceTypeWithLiteralsOriginal,
  ThinkingConfig as ThinkingConfigOriginal,
  McpServer as McpServerOriginal,
  McpServerType as McpServerTypeOriginal,
  McpServerTypeWithLiterals as McpServerTypeWithLiteralsOriginal,
  ToolConfiguration as ToolConfigurationOriginal,
  V1InvokeAnthropicClaudeModelRequest as V1InvokeAnthropicClaudeModelRequestOriginal,
  GoogleproxyV1InputSchema as GoogleproxyV1InputSchemaOriginal,
  ClaudeModel as ClaudeModelOriginal,
  ClaudeModelWithLiterals as ClaudeModelWithLiteralsOriginal,
  V1AnthropicClaudeMessage as V1AnthropicClaudeMessageOriginal,
  InvokeAnthropicClaudeModelRequestTool as InvokeAnthropicClaudeModelRequestToolOriginal,
  GoogleproxyV1ToolChoice as GoogleproxyV1ToolChoiceOriginal,
  GoogleproxyV1ToolChoiceType as GoogleproxyV1ToolChoiceTypeOriginal,
  GoogleproxyV1ToolChoiceTypeWithLiterals as GoogleproxyV1ToolChoiceTypeWithLiteralsOriginal,
  GoogleproxyV1ThinkingConfig as GoogleproxyV1ThinkingConfigOriginal,
  GoogleproxyV1McpServer as GoogleproxyV1McpServerOriginal,
  GoogleproxyV1McpServerType as GoogleproxyV1McpServerTypeOriginal,
  GoogleproxyV1McpServerTypeWithLiterals as GoogleproxyV1McpServerTypeWithLiteralsOriginal,
  V1McpServerToolConfiguration as V1McpServerToolConfigurationOriginal,
  InvokeAnthropicModelRequest as InvokeAnthropicModelRequestOriginal,
  AnthropicModel as AnthropicModelOriginal,
  AnthropicModelWithLiterals as AnthropicModelWithLiteralsOriginal,
  AnthropicMessage as AnthropicMessageOriginal,
  V1Tool as V1ToolOriginal,
  V1ToolKindOneOf as V1ToolKindOneOfOriginal,
  CustomTool as CustomToolOriginal,
  V1InputSchema as V1InputSchemaOriginal,
  ComputerUseTool as ComputerUseToolOriginal,
  TextEditorTool as TextEditorToolOriginal,
  BashTool as BashToolOriginal,
  WebSearchTool as WebSearchToolOriginal,
  WebSearchUserLocation as WebSearchUserLocationOriginal,
  CodeExecutionTool as CodeExecutionToolOriginal,
  WebFetchTool as WebFetchToolOriginal,
  V1ToolChoice as V1ToolChoiceOriginal,
  V1ToolChoiceType as V1ToolChoiceTypeOriginal,
  V1ToolChoiceTypeWithLiterals as V1ToolChoiceTypeWithLiteralsOriginal,
  V1ThinkingConfig as V1ThinkingConfigOriginal,
  V1McpServer as V1McpServerOriginal,
  V1McpServerType as V1McpServerTypeOriginal,
  V1McpServerTypeWithLiterals as V1McpServerTypeWithLiteralsOriginal,
  McpServerToolConfiguration as McpServerToolConfigurationOriginal,
  RequestMetadata as RequestMetadataOriginal,
  InvokeLlamaModelRequest as InvokeLlamaModelRequestOriginal,
  LlamaModel as LlamaModelOriginal,
  LlamaModelWithLiterals as LlamaModelWithLiteralsOriginal,
  InvokeConverseRequest as InvokeConverseRequestOriginal,
  ConverseModel as ConverseModelOriginal,
  ConverseModelWithLiterals as ConverseModelWithLiteralsOriginal,
  ConverseInferenceConfig as ConverseInferenceConfigOriginal,
  ToolConfig as ToolConfigOriginal,
  ConverseTool as ConverseToolOriginal,
  ToolSpecification as ToolSpecificationOriginal,
  ConverseInputSchema as ConverseInputSchemaOriginal,
  SystemContentBlock as SystemContentBlockOriginal,
  CreateImageRequest as CreateImageRequestOriginal,
  ImageQuality as ImageQualityOriginal,
  ImageQualityWithLiterals as ImageQualityWithLiteralsOriginal,
  ImageSize as ImageSizeOriginal,
  ImageSizeWithLiterals as ImageSizeWithLiteralsOriginal,
  ImageStyle as ImageStyleOriginal,
  ImageStyleWithLiterals as ImageStyleWithLiteralsOriginal,
  V1TextToImageRequest as V1TextToImageRequestOriginal,
  TextPrompt as TextPromptOriginal,
  ClipGuidancePreset as ClipGuidancePresetOriginal,
  ClipGuidancePresetWithLiterals as ClipGuidancePresetWithLiteralsOriginal,
  Sampler as SamplerOriginal,
  SamplerWithLiterals as SamplerWithLiteralsOriginal,
  TextToImageRequestStylePreset as TextToImageRequestStylePresetOriginal,
  TextToImageRequestStylePresetWithLiterals as TextToImageRequestStylePresetWithLiteralsOriginal,
  GenerateCoreRequest as GenerateCoreRequestOriginal,
  GenerateCoreRequestStylePreset as GenerateCoreRequestStylePresetOriginal,
  GenerateCoreRequestStylePresetWithLiterals as GenerateCoreRequestStylePresetWithLiteralsOriginal,
  GenerateStableDiffusionRequest as GenerateStableDiffusionRequestOriginal,
  GenerationMode as GenerationModeOriginal,
  GenerationModeWithLiterals as GenerationModeWithLiteralsOriginal,
  GenerateStableDiffusionRequestOutputFormat as GenerateStableDiffusionRequestOutputFormatOriginal,
  GenerateStableDiffusionRequestOutputFormatWithLiterals as GenerateStableDiffusionRequestOutputFormatWithLiteralsOriginal,
  GenerateAnImageRequest as GenerateAnImageRequestOriginal,
  GenerateAnImageModel as GenerateAnImageModelOriginal,
  GenerateAnImageModelWithLiterals as GenerateAnImageModelWithLiteralsOriginal,
  CreatePredictionRequest as CreatePredictionRequestOriginal,
  CreatePredictionRequestInputOneOf as CreatePredictionRequestInputOneOfOriginal,
  CreatePredictionModel as CreatePredictionModelOriginal,
  CreatePredictionModelWithLiterals as CreatePredictionModelWithLiteralsOriginal,
  FluxPulid as FluxPulidOriginal,
  FluxDevControlnet as FluxDevControlnetOriginal,
  ReveEdit as ReveEditOriginal,
  LucatacoFlorence2Large as LucatacoFlorence2LargeOriginal,
  TaskInput as TaskInputOriginal,
  TaskInputWithLiterals as TaskInputWithLiteralsOriginal,
  PerceptronIsaac01 as PerceptronIsaac01Original,
  ResponseType as ResponseTypeOriginal,
  ResponseTypeWithLiterals as ResponseTypeWithLiteralsOriginal,
  PrunaaiZImageTurbo as PrunaaiZImageTurboOriginal,
  QwenImageLayered as QwenImageLayeredOriginal,
  EditImageWithPromptRequest as EditImageWithPromptRequestOriginal,
  StylePreset as StylePresetOriginal,
  StylePresetWithLiterals as StylePresetWithLiteralsOriginal,
  OutpaintDirection as OutpaintDirectionOriginal,
  TextToImageRequest as TextToImageRequestOriginal,
  TextToImageRequestModel as TextToImageRequestModelOriginal,
  TextToImageRequestModelWithLiterals as TextToImageRequestModelWithLiteralsOriginal,
  LoraModelSelect as LoraModelSelectOriginal,
  Inputs as InputsOriginal,
  InvokeMlPlatformLlamaModelRequest as InvokeMlPlatformLlamaModelRequestOriginal,
  InvokeChatCompletionRequest as InvokeChatCompletionRequestOriginal,
  InvokeChatCompletionRequestResponseFormat as InvokeChatCompletionRequestResponseFormatOriginal,
  InvokeChatCompletionRequestResponseFormatFormatDetailsOneOf as InvokeChatCompletionRequestResponseFormatFormatDetailsOneOfOriginal,
  V1GenerateImageRequest as V1GenerateImageRequestOriginal,
  ImagenModel as ImagenModelOriginal,
  ImagenModelWithLiterals as ImagenModelWithLiteralsOriginal,
  Instance as InstanceOriginal,
  Parameters as ParametersOriginal,
  OutputOptions as OutputOptionsOriginal,
  GenerateImageMlPlatformRequest as GenerateImageMlPlatformRequestOriginal,
  GenerateImageMlPlatformRequestInputOneOf as GenerateImageMlPlatformRequestInputOneOfOriginal,
  GenerateImageMlPlatformModel as GenerateImageMlPlatformModelOriginal,
  GenerateImageMlPlatformModelWithLiterals as GenerateImageMlPlatformModelWithLiteralsOriginal,
  V1FluxPulid as V1FluxPulidOriginal,
  CreateImageOpenAiRequest as CreateImageOpenAiRequestOriginal,
  EditImageOpenAiRequest as EditImageOpenAiRequestOriginal,
  GenerateVideoRequest as GenerateVideoRequestOriginal,
  VideoGenModel as VideoGenModelOriginal,
  VideoGenModelWithLiterals as VideoGenModelWithLiteralsOriginal,
  GenerateVideoInstance as GenerateVideoInstanceOriginal,
  V1ImageInput as V1ImageInputOriginal,
  GenerateVideoParameters as GenerateVideoParametersOriginal,
  V1CreateChatCompletionRequest as V1CreateChatCompletionRequestOriginal,
  V1CreateChatCompletionRequestResponseFormat as V1CreateChatCompletionRequestResponseFormatOriginal,
  InvokeMlPlatformOpenAIChatCompletionRawRequest as InvokeMlPlatformOpenAIChatCompletionRawRequestOriginal,
  ResponseFormat as ResponseFormatOriginal,
  VideoInferenceRequest as VideoInferenceRequestOriginal,
  OutputFormat as OutputFormatOriginal,
  OutputFormatWithLiterals as OutputFormatWithLiteralsOriginal,
  FrameImage as FrameImageOriginal,
  VideoModel as VideoModelOriginal,
  VideoModelWithLiterals as VideoModelWithLiteralsOriginal,
  VideoInputs as VideoInputsOriginal,
  V1OpenAiResponsesRequest as V1OpenAiResponsesRequestOriginal,
  V1ResponsesInputItem as V1ResponsesInputItemOriginal,
  V1ResponsesInputItemItemOneOf as V1ResponsesInputItemItemOneOfOriginal,
  V1ResponsesInputMessage as V1ResponsesInputMessageOriginal,
  ResponsesInputMessageResponsesMessageRole as ResponsesInputMessageResponsesMessageRoleOriginal,
  ResponsesInputMessageResponsesMessageRoleWithLiterals as ResponsesInputMessageResponsesMessageRoleWithLiteralsOriginal,
  V1ResponsesInputMessageContent as V1ResponsesInputMessageContentOriginal,
  V1ResponsesInputMessageContentContentValueOneOf as V1ResponsesInputMessageContentContentValueOneOfOriginal,
  ResponsesInputMessageContentImageInput as ResponsesInputMessageContentImageInputOriginal,
  ResponsesInputMessageContentFileInput as ResponsesInputMessageContentFileInputOriginal,
  V1ResponsesFunctionToolCallOutput as V1ResponsesFunctionToolCallOutputOriginal,
  V1ResponsesTextFormat as V1ResponsesTextFormatOriginal,
  V1ResponsesTextFormatFormatOneOf as V1ResponsesTextFormatFormatOneOfOriginal,
  ResponsesTextFormatJsonSchema as ResponsesTextFormatJsonSchemaOriginal,
  V1ResponsesToolChoice as V1ResponsesToolChoiceOriginal,
  V1ResponsesTool as V1ResponsesToolOriginal,
  V1ResponsesToolToolTypeOneOf as V1ResponsesToolToolTypeOneOfOriginal,
  V1ResponsesWebSearch as V1ResponsesWebSearchOriginal,
  ResponsesWebSearchUserLocation as ResponsesWebSearchUserLocationOriginal,
  V1ResponsesFunction as V1ResponsesFunctionOriginal,
  V1ResponsesCodeInterpreter as V1ResponsesCodeInterpreterOriginal,
  V1ResponsesCodeInterpreterContainer as V1ResponsesCodeInterpreterContainerOriginal,
  V1ResponsesCodeInterpreterContainerContainerTypeOneOf as V1ResponsesCodeInterpreterContainerContainerTypeOneOfOriginal,
  V1ResponsesCodeInterpreterContainerAuto as V1ResponsesCodeInterpreterContainerAutoOriginal,
  OpenAiResponsesRequest as OpenAiResponsesRequestOriginal,
  ResponsesInputItem as ResponsesInputItemOriginal,
  ResponsesInputItemItemOneOf as ResponsesInputItemItemOneOfOriginal,
  ResponsesInputMessage as ResponsesInputMessageOriginal,
  ResponsesMessageRole as ResponsesMessageRoleOriginal,
  ResponsesMessageRoleWithLiterals as ResponsesMessageRoleWithLiteralsOriginal,
  ResponsesInputMessageContent as ResponsesInputMessageContentOriginal,
  ResponsesInputMessageContentContentValueOneOf as ResponsesInputMessageContentContentValueOneOfOriginal,
  ImageInput as ImageInputOriginal,
  FileInput as FileInputOriginal,
  ResponsesFunctionToolCallOutput as ResponsesFunctionToolCallOutputOriginal,
  ResponsesTextFormat as ResponsesTextFormatOriginal,
  ResponsesTextFormatFormatOneOf as ResponsesTextFormatFormatOneOfOriginal,
  JsonSchema as JsonSchemaOriginal,
  ResponsesToolChoice as ResponsesToolChoiceOriginal,
  ResponsesTool as ResponsesToolOriginal,
  ResponsesToolToolTypeOneOf as ResponsesToolToolTypeOneOfOriginal,
  ResponsesWebSearch as ResponsesWebSearchOriginal,
  UserLocation as UserLocationOriginal,
  ResponsesFunction as ResponsesFunctionOriginal,
  ResponsesCodeInterpreter as ResponsesCodeInterpreterOriginal,
  ResponsesCodeInterpreterContainer as ResponsesCodeInterpreterContainerOriginal,
  ResponsesCodeInterpreterContainerContainerTypeOneOf as ResponsesCodeInterpreterContainerContainerTypeOneOfOriginal,
  ResponsesCodeInterpreterContainerAuto as ResponsesCodeInterpreterContainerAutoOriginal,
  CreateVideoRequest as CreateVideoRequestOriginal,
  V1VideoModel as V1VideoModelOriginal,
  V1VideoModelWithLiterals as V1VideoModelWithLiteralsOriginal,
  InvokeCustomOpenAiModelRequest as InvokeCustomOpenAiModelRequestOriginal,
  InvokeCustomOpenAiModelRequestFunctionCallOneOf as InvokeCustomOpenAiModelRequestFunctionCallOneOfOriginal,
  InvokeCustomOpenAiModelRequestFunctionSignature as InvokeCustomOpenAiModelRequestFunctionSignatureOriginal,
  InvokeCustomOpenAiModelRequestTool as InvokeCustomOpenAiModelRequestToolOriginal,
  InvokeCustomOpenAiModelRequestResponseFormat as InvokeCustomOpenAiModelRequestResponseFormatOriginal,
  CreateContentTaskRequest as CreateContentTaskRequestOriginal,
  ContentItem as ContentItemOriginal,
  ImageUrl as ImageUrlOriginal,
  DraftTask as DraftTaskOriginal,
  GenerateImageRequest as GenerateImageRequestOriginal,
  SequentialImageGenerationOptions as SequentialImageGenerationOptionsOriginal,
  OptimizePromptOptions as OptimizePromptOptionsOriginal,
  UserRequestInfo as UserRequestInfoOriginal,
  FallbackProperties as FallbackPropertiesOriginal,
  AsyncGenerationConfig as AsyncGenerationConfigOriginal,
  SpiGenerationConfig as SpiGenerationConfigOriginal,
  DynamicRequestConfig as DynamicRequestConfigOriginal,
  GatewayToolDefinition as GatewayToolDefinitionOriginal,
  GatewayToolDefinitionToolOneOf as GatewayToolDefinitionToolOneOfOriginal,
  GatewayToolDefinitionCustomTool as GatewayToolDefinitionCustomToolOriginal,
  BuiltInTool as BuiltInToolOriginal,
  GatewayMessageDefinition as GatewayMessageDefinitionOriginal,
  GatewayMessageDefinitionRole as GatewayMessageDefinitionRoleOriginal,
  GatewayMessageDefinitionRoleWithLiterals as GatewayMessageDefinitionRoleWithLiteralsOriginal,
  GatewayContentBlock as GatewayContentBlockOriginal,
  GatewayContentBlockTypeOneOf as GatewayContentBlockTypeOneOfOriginal,
  ToolResultContent as ToolResultContentOriginal,
  GenerateContentByPromptObjectResponse as GenerateContentByPromptObjectResponseOriginal,
  GenerateTextByPromptObjectRequest as GenerateTextByPromptObjectRequestOriginal,
  GeneratedTextChunk as GeneratedTextChunkOriginal,
  GeneratedTextChunkModelChunkOneOf as GeneratedTextChunkModelChunkOneOfOriginal,
  ChatCompletionChunk as ChatCompletionChunkOriginal,
  ChunkDelta as ChunkDeltaOriginal,
  ChunkChoice as ChunkChoiceOriginal,
  OpenaiproxyV1ChatCompletionChunk as OpenaiproxyV1ChatCompletionChunkOriginal,
  ChatCompletionChunkChunkChoiceChunkDelta as ChatCompletionChunkChunkChoiceChunkDeltaOriginal,
  V1ChatCompletionChunkChunkChoice as V1ChatCompletionChunkChunkChoiceOriginal,
  GoogleproxyV1AnthropicStreamChunk as GoogleproxyV1AnthropicStreamChunkOriginal,
  GoogleproxyV1AnthropicStreamChunkContentOneOf as GoogleproxyV1AnthropicStreamChunkContentOneOfOriginal,
  GoogleproxyV1ContentBlockDelta as GoogleproxyV1ContentBlockDeltaOriginal,
  GoogleproxyV1ContentBlockDeltaDeltaOneOf as GoogleproxyV1ContentBlockDeltaDeltaOneOfOriginal,
  V1AnthropicStreamChunkMessageDelta as V1AnthropicStreamChunkMessageDeltaOriginal,
  AnthropicStreamChunk as AnthropicStreamChunkOriginal,
  AnthropicStreamChunkContentOneOf as AnthropicStreamChunkContentOneOfOriginal,
  ContentBlockDelta as ContentBlockDeltaOriginal,
  ContentBlockDeltaDeltaOneOf as ContentBlockDeltaDeltaOneOfOriginal,
  MessageDelta as MessageDeltaOriginal,
  V1AnthropicStreamChunk as V1AnthropicStreamChunkOriginal,
  V1AnthropicStreamChunkContentOneOf as V1AnthropicStreamChunkContentOneOfOriginal,
  V1ContentBlockDelta as V1ContentBlockDeltaOriginal,
  V1ContentBlockDeltaDeltaOneOf as V1ContentBlockDeltaDeltaOneOfOriginal,
  AnthropicStreamChunkMessageDelta as AnthropicStreamChunkMessageDeltaOriginal,
  V1ChatCompletionChunk as V1ChatCompletionChunkOriginal,
  ChunkChoiceChunkDelta as ChunkChoiceChunkDeltaOriginal,
  ChatCompletionChunkChunkChoice as ChatCompletionChunkChunkChoiceOriginal,
  GenerateAudioRequest as GenerateAudioRequestOriginal,
  GenerateAudioRequestAudioRequestOneOf as GenerateAudioRequestAudioRequestOneOfOriginal,
  CreateSpeechRequest as CreateSpeechRequestOriginal,
  SpeechModel as SpeechModelOriginal,
  SpeechModelWithLiterals as SpeechModelWithLiteralsOriginal,
  TextToSpeechRequest as TextToSpeechRequestOriginal,
  ElevenLabsTextToSpeechModel as ElevenLabsTextToSpeechModelOriginal,
  ElevenLabsTextToSpeechModelWithLiterals as ElevenLabsTextToSpeechModelWithLiteralsOriginal,
  VoiceSettings as VoiceSettingsOriginal,
  PronunciationDictionaryLocator as PronunciationDictionaryLocatorOriginal,
  GeneratedAudioChunk as GeneratedAudioChunkOriginal,
  GeneratedAudioChunkAudioChunkOneOf as GeneratedAudioChunkAudioChunkOneOfOriginal,
  SpeechChunk as SpeechChunkOriginal,
  TextToSpeechChunk as TextToSpeechChunkOriginal,
  AlignmentInfoInChunk as AlignmentInfoInChunkOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './api-infra-v1-prompt-proxy-prompts.types.js';
